import { useMemo } from 'react';
import { Avatar as MUIAvatar } from '@mui/material';
import styled from 'styled-components';

import { IUserGender } from '@shared/types';
import { useResolveImagePath } from '../../hooks/useResolveImagePath';

interface IProps {
  gender: IUserGender;
  src?: string;
  alt?: string;
}

const StyledAvatar = styled(MUIAvatar)``;
const FEMALE_ICON_URL = 'https://cdn-icons-png.flaticon.com/512/6858/6858495.png';
const MALE_ICON_URL = 'https://cdn-icons-png.flaticon.com/512/6858/6858504.png';

export const Avatar = ({ gender = 'Male', src, alt }: IProps) => {
  const fallbackAvatar = useMemo(() => (gender === 'Female' ? FEMALE_ICON_URL : MALE_ICON_URL), [gender]);
  const resolvedSrc = useResolveImagePath(src, fallbackAvatar);

  if (resolvedSrc === undefined) {
    return <StyledAvatar>{alt?.[0] || 'U'}</StyledAvatar>;
  }

  return <StyledAvatar src={resolvedSrc} alt={alt ?? 'avatar'} />;
};
